<div class="page-container">
  <p-card>
    <ng-template pTemplate="header">
      <div class="p-3">
        <h2 class="m-0">
          <i class="pi pi-car mr-2"></i>Fuel Entry Form
        </h2>
        <p class="text-color-secondary mt-1 mb-0">Record a new fuel transaction</p>
      </div>
    </ng-template>

    <form #fuelForm="ngForm" (ngSubmit)="onSubmit()">

      <!-- Vehicle Information -->
      <div class="card-section">
        <h3 class="section-title">Vehicle Information</h3>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="truckNumber" class="font-semibold">
              Truck Number <span class="required">*</span>
            </label>
            <p-dropdown
              id="truckNumber"
              [options]="truckOptions"
              [(ngModel)]="selectedTruck"
              name="truckNumber"
              optionLabel="label"
              placeholder="Select a truck"
              [disabled]="isLoadingTrucks"
              [loading]="isLoadingTrucks"
              styleClass="w-full"
              required>
            </p-dropdown>
            <small *ngIf="isLoadingTrucks" class="text-color-secondary">Loading trucks from Dropbox...</small>
          </div>
        </div>
      </div>

      <!-- Invoice Details -->
      <div class="card-section">
        <h3 class="section-title">Invoice Details</h3>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="invoiceNumber" class="font-semibold">Invoice Number</label>
            <input
              pInputText
              id="invoiceNumber"
              name="invoiceNumber"
              [(ngModel)]="formData.invoiceNumber"
              placeholder="e.g. 00025909"
              class="w-full" />
            <small class="text-color-secondary">Optional</small>
          </div>

          <div class="field col-12 md:col-6">
            <label for="invoiceDate" class="font-semibold">
              Invoice Date <span class="required">*</span>
            </label>
            <p-calendar
              id="invoiceDate"
              name="invoiceDate"
              [(ngModel)]="selectedInvoiceDate"
              dateFormat="mm/dd/yy"
              [showIcon]="true"
              placeholder="MM/DD/YYYY"
              styleClass="w-full"
              required>
            </p-calendar>
          </div>
        </div>
      </div>

      <!-- Vendor Information -->
      <div class="card-section">
        <h3 class="section-title">Vendor Information</h3>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="vendor" class="font-semibold">
              Vendor <span class="required">*</span>
            </label>
            <input
              pInputText
              id="vendor"
              name="Vendor"
              [(ngModel)]="formData.Vendor"
              placeholder="e.g. KWIK TRIP"
              minlength="2"
              required
              class="w-full uppercase-input" />
          </div>

          <div class="field col-12 md:col-6">
            <label for="city" class="font-semibold">
              City <span class="required">*</span>
            </label>
            <input
              pInputText
              id="city"
              name="City"
              [(ngModel)]="formData.City"
              placeholder="e.g. MT PLEASANT"
              minlength="2"
              required
              class="w-full uppercase-input" />
          </div>

          <div class="field col-12 md:col-4">
            <label for="state" class="font-semibold">
              State <span class="required">*</span>
            </label>
            <input
              pInputText
              id="state"
              name="State"
              [(ngModel)]="formData.State"
              placeholder="WI"
              minlength="2"
              maxlength="2"
              pattern="[A-Za-z]{2}"
              required
              class="w-full uppercase-input" />
          </div>

          <div class="field col-12 md:col-4">
            <label for="postalCode" class="font-semibold">
              Postal Code <span class="required">*</span>
            </label>
            <input
              pInputText
              id="postalCode"
              name="PostalCode"
              [(ngModel)]="formData.PostalCode"
              placeholder="53177"
              pattern="[0-9]{5}(-[0-9]{4})?"
              required
              class="w-full" />
          </div>
        </div>
      </div>

      <!-- Fuel Details -->
      <div class="card-section">
        <h3 class="section-title">Fuel Details</h3>
        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="quantity" class="font-semibold">
              Quantity (Gallons) <span class="required">*</span>
            </label>
            <p-inputNumber
              id="quantity"
              name="Quantity"
              [(ngModel)]="formData.Quantity"
              [min]="0.01"
              [max]="999999"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              mode="decimal"
              placeholder="0.00"
              styleClass="w-full"
              required>
            </p-inputNumber>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex gap-2 justify-content-end mt-3">
        <button type="button"
          class="p-button p-button-secondary p-button-outlined"
          (click)="resetForm()">
          <i class="pi pi-times mr-2"></i>Reset
        </button>
        <button type="submit"
          class="p-button"
          [disabled]="!isFormValid() || isSubmitting">
          <i [class]="isSubmitting ? 'pi pi-spin pi-spinner mr-2' : 'pi pi-check mr-2'"></i>
          {{ isSubmitting ? 'Submitting...' : 'Submit Fuel Entry' }}
        </button>
      </div>
    </form>
  </p-card>
</div>
